import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, onBeforeUpdate, watch } from "vue";
    import Highcharts from "highcharts";
    import { Chart } from "highcharts-vue";
    import ChartSeries from "@/guiide/ts/chartSeries";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DBOptionsChart',
  props: {
        graphData: { type: Object as () => any, required: true, default: () => ({}) }
    },
  setup(__props) {

    const props = __props;

    const IncChart = ref(null);

    const isYAxisLocked = ref(false);

    let yAxisMaxToLockAt = 0;

    const maxAnnualPayment = ref(0);

    watch(
        () => props.graphData,
        (latestGraphData) => {
            if (!latestGraphData || latestGraphData.length == 0 || (latestGraphData[0].data?.length ?? 0) == 0) {
                return;
            }

            const payments = latestGraphData?.flatMap(series => series.data?.map(point => point[1]) || []).filter(v => !isNaN(v)) || [0];

            maxAnnualPayment.value = Math.max(...payments);
            if (!isYAxisLocked.value) {
                yAxisMaxToLockAt = Math.floor((maxAnnualPayment.value + 4999) / 5000) * 5000;
            }
        },
        { immediate: true, deep: true }
    );

    onBeforeUpdate(() => {
        if (IncChart.value?.chart) {
            IncChart.value.chart.reflow();
        }
    });

    const incomeChartOptions = computed<object>(() => {
        return {
            chart: {
                backgroundColor: "white",
                borderColor: "",
                borderWidth: 1,
                borderRadius: 3,
                zoomType: "x",
                panning: true,
                panKey: "shift",
                type: "column",
                height: 400,
                spacingTop: 25,
                events: {
                    load: function () {
                        const chart = this;

                        chart.customButton = chart.renderer.button(
                            '<i class="bi bi-unlock-fill"></i>',
                            11,
                            12,
                            function () {
                                if (isYAxisLocked.value) {
                                    yAxisMaxToLockAt = Math.floor((maxAnnualPayment.value + 4999) / 5000) * 5000;
                                }

                                chart.yAxis[0].update({
                                    max: yAxisMaxToLockAt
                                });

                                isYAxisLocked.value = !isYAxisLocked.value;

                                chart.customButton.attr({
                                    text: isYAxisLocked.value
                                        ? '<i class="bi bi-lock-fill"></i>'
                                        : '<i class="bi bi-unlock-fill"></i>',
                                    'aria-label': isYAxisLocked.value
                                        ? 'Unlock y axis'
                                        : 'Lock y axis'
                                });
                            },
                            {
                                padding: 0,
                                width: 28,
                                height: 28,
                                style: {
                                    fontSize: '16px',
                                    lineHeight: '18px',
                                    textAlign: 'center',
                                    cursor: 'pointer'
                                }
                            },
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            true
                        ).add();

                        chart.customButton.attr({
                            'aria-label': 'Unlock y axis'
                        });
                    }
                }
            },
            title: {
                text: "Annual payments expected",
                y: -5,
                style: {
                    color: "#5c5b5b",
                    fontWeight: "600",
                    fontSize: "16px"
                }
            },
            xAxis: {
                title: {
                    text: "Age",
                    style: {
                        color: "#5c5b5b",
                        fontSize: "12px"
                    }
                },
                allowDecimals: false,
                tickInterval: 1,
                tickLength: 0
            },
            yAxis: {
                min: 0,
                max: yAxisMaxToLockAt,
                endOnTick: true,
                title: {
                    text: "",
                    rotation: 0,
                    style: {
                        color: "Black",
                        fontWeight: "500",
                        fontSize: "14px"
                    }
                },
                labels: {
                    formatter: function () {
                        return (
                            "£" + Highcharts.numberFormat(this.value / 1000, 0, ".", ",") + "k"
                        );
                    }
                },
                stackLabels: {
                    enabled: false,
                    style: {
                        fontWeight: "bold",
                        color: "gray"
                    }
                }
            },
            legend: {
                enabled: true,
                align: 'right',
                verticalAlign: "top",
                floating: true,
                backgroundColor: "white",
                borderColor: "",
                borderWidth: 0,
                borderRadius: 0,
                shadow: false,
                itemStyle: {
                    color: "Grey",
                    fontWeight: "lighter",
                    fontSize: "12px"
                }
            },
            tooltip: {
                animation: true,
                valuePrefix: '£'
            },
            plotOptions: {
                line: {
                    pointStart: 1
                },
                column: {
                    pointPadding: -0.1,
                    borderWidth: 1,
                    shadow: false,
                    borderRadius: 0,
                    stacking: "normal",
                    dataLabels: {
                        enabled: false,
                        color: "black"
                    },
                    pointStart: 1,
                    cursor: "pointer"
                }
            },
            series: props.graphData,
            credits: {
                enabled: false
            }
        };
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Chart), {
      ref_key: "IncChart",
      ref: IncChart,
      options: incomeChartOptions.value
    }, null, 8, ["options"])
  ]))
}
}

})